import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';

const StyledOperators = styled.div`
  margin-bottom: 10px;
  text-align: center;
  color: ${(props) => props.theme.colors.greyLight};
`;

const SearcherOperators = ({ items }) => {
  const { t } = useTranslation();
  return Array.isArray(items) ? (
    <StyledOperators>
      {`${t('hotel.operators')}: `}
      {items.join(', ')}
    </StyledOperators>
  ) : null;
};

SearcherOperators.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string.isRequired),
};

SearcherOperators.defaultProps = {
  items: null,
};

export default SearcherOperators;
